import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';

// Layout
import Layout from './components/Layout';

// Public Pages per Section 4 & 5 of docs/new/new-sbb.md
import Home from './pages/Home';
import ProductListing from './pages/ProductListing';
import SolutionCategoryDetail from './pages/SolutionCategoryDetail';
import ProductDetail from './pages/ProductDetail';
import AboutUs from './pages/AboutUs';
import OperationalLocations from './pages/OperationalLocations';
import CertificatesAwards from './pages/CertificatesAwards';
import ProjectListing from './pages/ProjectListing';
import ProjectDetail from './pages/ProjectDetail';
import Sustainability from './pages/Sustainability';
import NewsArticlesListing from './pages/NewsArticlesListing';
import NewsArticleDetail from './pages/NewsArticleDetail';
import ContactUs from './pages/ContactUs';
import SearchPage from './pages/SearchPage';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Existing Admin & Portal pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import UserPanel from './pages/UserPanel';
import Cart from './pages/Cart';
import Login from './pages/Login';

import './index.css';
import './admin.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          {/* Admin routes — no main Layout */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />

          {/* User portal — no main Layout */}
          <Route path="/portal" element={<UserPanel />} />

          {/* Public routes — with Layout */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                
                {/* Product & Solutions Routes */}
                <Route path="/produk-layanan" element={<ProductListing />} />
                <Route path="/produk-layanan/:categorySlug" element={<SolutionCategoryDetail />} />
                <Route path="/produk-layanan/detail/:productSlug" element={<ProductDetail />} />

                {/* Corporate & Info Routes */}
                <Route path="/tentang-kami" element={<AboutUs />} />
                <Route path="/lokasi-operasional-kami" element={<OperationalLocations />} />
                <Route path="/sertifikat-penghargaan" element={<CertificatesAwards />} />
                <Route path="/pelanggan-proyek" element={<ProjectListing />} />
                <Route path="/proyek/:projectSlug" element={<ProjectDetail />} />
                <Route path="/keberlanjutan" element={<Sustainability />} />
                
                {/* Media & Articles Routes */}
                <Route path="/blog" element={<NewsArticlesListing />} />
                <Route path="/blog/:postSlug" element={<NewsArticleDetail />} />
                
                {/* Contact, Search & Legal */}
                <Route path="/kontak-kami" element={<ContactUs />} />
                <Route path="/pencarian" element={<SearchPage />} />
                <Route path="/kebijakan-privasi" element={<PrivacyPolicy />} />

                {/* Legacy Portal/Cart Routes */}
                <Route path="/cart" element={<Cart />} />
                <Route path="/login" element={<Login />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
